import React, { Component } from "react";
import { notification, message, Spin } from 'antd';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

export default class EmbCenso extends Component{

  state = {
    censoemb:[],
    loading: false
  }
  
  componentDidMount() {
    
    // let id_interval = setInterval(() => {

      const { unidad_medica_user, periodo, backend } = this.props;

      fetch(`${backend}/censoemb/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
        // debugger
          this.setState({
            censoemb: data.data,
            loading: true
          })
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener la información de censo de embarazadas del último mes.",
          });
          message.destroy()
      });

    // }, 3000);
  }


  render(){

    const { censoemb, loading } = this.state;                     

    return(
      loading ? 
        <div>
          <span className="format-titles-pnl-2">No. de pacientes embarazadas: {censoemb.length}</span>  
          
          <Box sx={{ m: 0.5 }} />

          <TableContainer component={Paper}>
            <Table 
            sx={{ 
              // minWidth: 700 
              // maxWidth:700
            }} 
            size="small" aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Nombre</StyledTableCell>
                  <StyledTableCell align="center">Edad</StyledTableCell>
                  <StyledTableCell align="center">Comorbilidades</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {censoemb  .map((row) => (
                  <StyledTableRow key={row.nombre}>
                    <StyledTableCell component="th" scope="row">
                      {row.nombre}
                    </StyledTableCell>
                    <StyledTableCell align="center">{row.edad}</StyledTableCell>
                    <StyledTableCell align="center">{row.comorbilidades}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        : <Spin size="small" />
    );
  }
}


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    backgroundColor:'rgb(36, 98, 151)',
    color: theme.palette.common.white,
    fontWeight:'bold',
    fontSize:17
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));